var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.978,
    height: 23.979,
    viewBox: "0 0 23.978 23.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "exit",
    d: "M17.231,18.167v1.854a3.712,3.712,0,0,1-3.708,3.708H4.208A3.712,3.712,0,0,1,.5,20.021V3.708A3.712,3.712,0,0,1,4.208,0h9.315a3.712,3.712,0,0,1,3.708,3.708V5.561a.927.927,0,0,1-1.854,0V3.708a1.856,1.856,0,0,0-1.854-1.854H4.208A1.856,1.856,0,0,0,2.354,3.708V20.021a1.856,1.856,0,0,0,1.854,1.854h9.315a1.856,1.856,0,0,0,1.854-1.854V18.167a.927.927,0,0,1,1.854,0Zm6.319-7.9L21.474,8.2a.927.927,0,0,0-1.311,1.311l1.476,1.477H10.511a.927.927,0,1,0,0,1.854H21.64l-1.476,1.477a.927.927,0,1,0,1.311,1.311l2.076-2.076A2.32,2.32,0,0,0,23.55,10.272Zm0,0",
    transform: "translate(-0.375 0.125)",
    fill: "#ff5059",
    stroke: "#ff5059",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4942429c537637eaaa82b5c0807412a7.svg";
export { ForwardRef as ReactComponent };